import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography
} from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";

const Licensesummary = ({ reportdata, service, level }) => {
  const currentyear = new Date().getFullYear();
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options); // 'en-GB' locale for dd/mm/yyyy format
  };
  return (
    <>
      <div>
        <div style={{ padding: '20px', marginTop: '20px' }}>
          <TableContainer component={Paper} style={{ marginTop: '20px', overflow: 'visible' }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ flexGrow: 1, marginBottom: '30px' }}>
              {/* Logo Section */}
              <Grid item style={{ marginRight: '20px' }}>
                <img src={reportslogo} alt="logo" style={{ maxWidth: '180px', height: '180px' }} />
              </Grid>

              {/* Text Section */}
              <Grid item xs={12} md={8} style={{ textAlign: 'left', marginRight: '10px' }}>
                {/* Title */}
                <Typography variant="h6" style={{ margin: '0', fontSize: '30px', fontWeight: 'bold' }}>
                  License Master List - Summary
                </Typography>

                {/* Hospital and Service */}
                <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                  <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    {/* Hospital Master */}
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginRight: '20px', // Adjust space between label and value
                      }}
                    >
                      Hospital Master :
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',
                        fontWeight: 'normal',
                      }}
                    >
                      {level === 0
                        ? 'All'
                        : level === 1
                          ? localStorage.getItem('FacilityName')
                          : ''}
                    </Typography>

                  </Grid>

                  <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    {/* Service */}
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',
                        fontWeight: 'bold',

                        marginRight: '20px',// Adding margin between label and value
                      }}
                    >
                      Service&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',

                        fontWeight: 'normal',
                      }}
                    >
                      {service.label}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    {/* Service */}
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',
                        fontWeight: 'bold',

                        marginRight: '20px',// Adding margin between label and value
                      }}
                    >
                      Year&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: '18px',

                        fontWeight: 'normal',
                      }}
                    >
                      {currentyear}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* <Table aria-label="contract master summary table"> */}
            <TableHead >
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', padding: '8px', border: "1px solid black", textAlign: "center" }} rowSpan={2}>
                  No
                </TableCell>
                {level === 0 && (
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      color: 'black',
                      padding: '8px',
                      border: '1px solid black',
                      textAlign: 'center',
                    }}
                    rowSpan={2}
                  >
                    Hospital
                  </TableCell>
                )}




                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  License Number
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  License Category
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  License Type Code
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  License Type Description
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  Issue Date
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  Next Inspection Date
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  Expiry Date
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  Remarks
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'black', border: "1px solid black", textAlign: "center", }} rowSpan={2}>
                  Status
                </TableCell>
              </TableRow>

            </TableHead>

            <TableBody>
              {reportdata && reportdata.length > 0 ? (
                reportdata.map((contract, index) => (
                  <TableRow key={index} style={{ height: '40px' }}>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{index + 1}</TableCell>
                    {level === 0 && (<TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.hospital || ''}</TableCell>)}
                    {/* <TableCell style={{ padding: '4px',border: "1px solid black"  }}>{contract.companyName || ''}</TableCell> */}
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.licenseno || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.licensecategory || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.licensetypecode || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.licensetypecodedesc || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.issuedate || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.nextinspectiondate || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.expirydate || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.remarks || ''}</TableCell>
                    <TableCell style={{ padding: '4px', border: "1px solid black" }}>{contract.licensestatus || ''}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" style={{ border: "1px solid black" }}>
                    No Record available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            {/* </Table> */}
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default Licensesummary;
